// Regras PURAS do editor de cobertura da Rede Everlog (PO1-3648, épico
// PO1-3359): uma rota é um par origem → destino, e cada lado é uma UF inteira
// ou uma cidade. Sem React, para testar isolado e reaproveitar na página
// pública e no MeuFrete.

export const MAX_ROTAS = 200;
export const MIN_ROTAS = 1;

// Lado "vazio" de uma rota: a UI começa em modo UF, sem nada escolhido.
export function ladoVazio() {
  return { modo: "uf", idEstado: null, uf: "", idCidade: null, cidade: "" };
}

export function rotaVazia() {
  return { origem: ladoVazio(), destino: ladoVazio() };
}

// Um lado está completo quando tem a cidade (modo cidade) ou a UF (modo UF).
export function ladoCompleto(lado) {
  if (!lado) return false;
  if (lado.modo === "cidade") return Boolean(lado.idCidade);
  return Boolean(lado.idEstado);
}

export function rotaCompleta(rota) {
  return Boolean(rota) && ladoCompleto(rota.origem) && ladoCompleto(rota.destino);
}

// Mensagem de erro da lista inteira, ou null quando está válida. Mínimo de 1
// rota completa, máximo de 200, nenhuma pela metade.
export function validarCobertura(rotas) {
  const lista = Array.isArray(rotas) ? rotas : [];
  if (lista.length > MAX_ROTAS) return `No máximo ${MAX_ROTAS} rotas.`;
  const completas = lista.filter(rotaCompleta);
  if (completas.length < MIN_ROTAS) return "Informe pelo menos uma rota completa (origem e destino).";
  if (completas.length !== lista.length) return "Complete a origem e o destino de todas as rotas, ou remova as incompletas.";
  return null;
}

// Lado no formato do contrato: { idCidade } quando é cidade, { idEstado } quando é UF.
export function ladoParaPayload(lado) {
  if (lado.modo === "cidade" && lado.idCidade) return { idCidade: Number(lado.idCidade) };
  return { idEstado: Number(lado.idEstado) };
}

// Lista no formato que POST /public/rede-everlog/pedido (campo `cobertura`) e
// PUT /meufrete/rede/cobertura (`rotas`) recebem.
export function coberturaParaPayload(rotas) {
  return (rotas || []).filter(rotaCompleta).map((r) => ({ origem: ladoParaPayload(r.origem), destino: ladoParaPayload(r.destino) }));
}

// O inverso: o que a API devolve ({ idCidade, cidade, idEstado, uf }) vira o
// estado do editor. Com cidade, o modo é cidade; só UF, modo UF.
export function ladoDaApi(lado) {
  const l = lado || {};
  return {
    modo: l.idCidade ? "cidade" : "uf",
    idEstado: l.idEstado || null,
    uf: l.uf || "",
    idCidade: l.idCidade || null,
    cidade: l.cidade || "",
  };
}

export function coberturaDaApi(items) {
  return (items || []).map((r) => ({ id: r.id, origem: ladoDaApi(r.origem), destino: ladoDaApi(r.destino) }));
}

// Texto curto de um lado ("Campinas/SP" ou "SP").
export function rotuloLado(lado) {
  if (!lado) return "—";
  if (lado.modo === "cidade" && lado.cidade) return `${lado.cidade}/${lado.uf || ""}`.replace(/\/$/, "");
  return lado.uf || "—";
}

export function rotuloRota(rota) {
  return `${rotuloLado(rota.origem)} → ${rotuloLado(rota.destino)}`;
}
